import { Phone, MessageCircle } from "lucide-react";
import { buildWhatsAppLink, HOTLINE } from "@/lib/contact";

// Vertical FAB stack: WhatsApp (chat) + Phone call. Pulses gold to draw the eye.
export default function ConciergeFab() {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3" data-testid="concierge-fab">
      {/* Phone call */}
      <a href={`tel:${HOTLINE}`}
         data-testid="fab-call"
         aria-label="Call concierge"
         className="group relative">
        <span className="absolute inset-0 rounded-full bg-gold-600/25 blur-md group-hover:bg-gold-600/45 transition-all" />
        <span className="relative flex items-center justify-center w-12 h-12 bg-cream-100 text-forest-700 rounded-full border border-gold-600/50 shadow-[0_12px_30px_-12px_rgba(27,48,34,0.5)] hover:bg-cream-50 transition-colors">
          <Phone className="w-5 h-5 text-gold-700" />
        </span>
      </a>

      {/* WhatsApp chat */}
      <a href={buildWhatsAppLink("Hello Naljuri Inn — I'd like to inquire about a stay.")}
         target="_blank" rel="noreferrer"
         data-testid="fab-whatsapp"
         aria-label="Chat on WhatsApp"
         className="group relative">
        <span className="absolute inset-0 rounded-full bg-gold-600/30 blur-xl group-hover:bg-gold-600/55 transition-all" />
        <span className="relative flex items-center gap-2 bg-forest-700 text-cream-100 pl-4 pr-5 py-3.5 rounded-full border border-gold-600/40 shadow-[0_18px_40px_-12px_rgba(27,48,34,0.6)] hover:bg-forest-800 transition-colors">
          <span className="relative">
            <span className="absolute inset-0 rounded-full bg-gold-600/40 animate-ping" />
            <MessageCircle className="relative w-5 h-5 text-gold-400" />
          </span>
          <span className="hidden sm:inline text-[12px] tracking-wide">Concierge</span>
        </span>
      </a>
    </div>
  );
}
